import "./App.css";
import AuthProvider from "./auth/AuthContext.js";
import Navbar from "./Pages/navbar/navbar.js";
import MainSection from "./Pages/Routes/routes.js";
import { useAuth } from "react-oidc-context";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { App as AntdApp } from "antd";
import { setAntdMessageApi } from "./components/antdMessageBridge";
import { useAuthToken } from "./components/usecontext/AuthContext";
import useTracking from "./hooks/useTracking";
import { useAuth as useUserAuth } from "./auth/AuthContext";

const MessageBridge = () => {
    const { message: messageApi } = AntdApp.useApp();

    useEffect(() => {
        setAntdMessageApi(messageApi);
    }, [messageApi]);

    return null;
};

const TrackingBridge = () => {
    const { accessToken } = useAuthToken();
    const { roleUserId, userRoles } = useUserAuth();
    const location = useLocation();

    const actorUserRole = Array.isArray(userRoles)
        ? userRoles
              .map((role) => role?.roleName)
              .filter(Boolean)
              .join(",")
        : "";

    useTracking({
        accessToken,
        userId: roleUserId,
        actorUserRole,
        getMetadata: () => ({
            pagePath: location.pathname,
            pageQuery: location.search,
            pageHash: location.hash,
        }),
    });

    return null;
};

function App() {
    const auth = useAuth();
    const location = useLocation();

    return (
        <AntdApp>
            <MessageBridge />
            <div className="App">
                <AuthProvider>
                    <TrackingBridge />
                    {location.pathname !== '/' && <Navbar />}
                    <MainSection />
                </AuthProvider>
            </div>
        </AntdApp>
    );
}

export default App;
